import React, { useState, useRef, useEffect } from "react";
import style from "./componentCss/ContactForm.module.css";
import { nameValidator, detailValidator, emailValidator } from '../validator';
import Button from "./Button";
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from "react-i18next";
import { MapPin, Mail, Send } from 'lucide-react';
import MapComponent from './MapComponent';

const ContactForm = () => {
  const { t } = useTranslation();

  // Garder l’état pour validation, comme avant
  const [nameValidate, setNameValidate] = useState({ touched: false, error: false, message: '' });
  const [emailValidate, setEmailValidate] = useState({ touched: false, error: false, message: '' });
  const [detailValidate, setDetailValidate] = useState({ touched: false, error: false, message: '' });
  const [mounted, setMounted] = useState(false);

  const emailRef = useRef(null);
  const nameRef = useRef(null);
  const detailRef = useRef(null);

  const isMobile = useMediaQuery({ query: '(max-width: 800px)' });

  // Prend la validation de l'ancien code
  const handleName = () => {
    const nameRefValue = nameRef.current ? nameRef.current.value : "";
    const result = nameValidator(nameRefValue);
    setNameValidate(result);
  }

  const handleEmail = () => {
    const emailRefValue = emailRef.current ? emailRef.current.value : "";
    const result = emailValidator(emailRefValue);
    setEmailValidate(result);
  }

  const handleDetail = () => {
    const detailRefValue = detailRef.current ? detailRef.current.value : "";
    const result = detailValidator(detailRefValue);
    setDetailValidate(result);
  }

  // Optionnel : petite anim
  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted ? (
    <div className={style.contactWrapper}>
      <div className={style.contactContainer}>
        <div className={style.contactInfoCard}>
          <a
            href="https://maps.app.goo.gl/zCVwAEzCPscbVwa48"
            target="_blank"
            rel="noopener noreferrer"
            className={style.contactRow}
          >
            <div className={style.icon}><MapPin size={20} /></div>
            <div>
              <div className={style.label}>{t("ContactForm.Address")}</div>
              <div className={style.value}>31670 Labège, Occitanie, France</div>
            </div>
          </a>

          <a href="mailto:contact@koboct.com" className={style.contactRow}>
            <div className={style.icon}><Mail size={20} /></div>
            <div>
              <div className={style.label}>{t("ContactForm.EmailUs")}</div>
              <div className={style.value}>contact@koboct.com</div>
            </div>
          </a>
        <MapComponent />
        </div>

        <div className={style.contactFormCard}>
          <h2 className={style.title}>{t("ContactForm.ContactForm")}</h2>
          <form
            action="https://formspree.io/f/xrgjqqlw"
            method="POST"
            className={style.form}
          >
            <div className={`${style.inputGroup} ${nameValidate.touched ? (nameValidate.error ? style.error : style.success) : style.initial}`}>
              <label htmlFor="name">{t("ContactForm.name")}</label>
              <input onChange={handleName} ref={nameRef} type="text" id="name" name="name" required />
            </div>

            <div className={`${style.inputGroup} ${emailValidate.touched ? (emailValidate.error ? style.error : style.success) : style.initial}`}>
              <label htmlFor="email">{t("ContactForm.email")}</label>
              <input onChange={handleEmail} ref={emailRef} type="email" id="email" name="email" required />
            </div>

            <div className={`${style.inputGroup} ${detailValidate.touched ? (detailValidate.error ? style.error : style.success) : style.initial}`}>
              <label htmlFor="detail">{t("ContactForm.msg")}</label>
              <textarea onChange={handleDetail} ref={detailRef} id="detail" name="message" required />
            </div>

            {nameValidate.touched && !nameValidate.error && emailValidate.touched && !emailValidate.error && detailValidate.touched && !detailValidate.error
              ?
              <Button type="submit" width={isMobile ? '100%' : '160px'}>
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                  {t("ContactForm.send")}
                  <Send size={16} style={{ marginLeft: '8px' }} />
                </span>
              </Button>
              :
              <Button type="submit" width={isMobile ? '100%' : '160px'} backgroundColor='gray' disabled={true}>
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                  {t("ContactForm.send")}
                  <Send size={16} style={{ marginLeft: '8px' }} />
                </span>
              </Button>
            }
          </form>
        </div>
      </div>
    </div>
  ) : null;
};

export default ContactForm;
